<app-form-section headerKey="label.type" *ngIf="residentType == ResidentType.LANDLORD">
  <app-radio-input
    [disabled]="!(create || estate?.type == EstateType.COMMUNITY) || disablePersonal"
    [options]="landlordTypes"
    [formControl]="companyControl"
  ></app-radio-input>
</app-form-section>
<form [formGroup]="mainForm" id="form">
  <app-form-section>
    <ng-container section-header>
      {{ (isCompany ? 'sub.firmData' : 'user.personal') | locCap }}
      <app-slide-toggle-input labelKey="button.edit" [formControl]="editPersonalControl"></app-slide-toggle-input>
    </ng-container>
    <div *ngIf="isCompany" class="grid-70-30">
      <app-text-input
        labelKey="label.nip"
        formControlName="NIP"
        [required]="true"
        placeholderKey="label.nip"
        [disabled]="disablePersonal"
      ></app-text-input>
      <app-gus-autofill-button
        [nip]="mainForm.controls.NIP.value"
        [disabled]="!mainForm.controls.NIP.valid || disablePersonal"
        (resolveGusData)="resolveGusData($event)"
      ></app-gus-autofill-button>
    </div>
    <div [ngClass]="{ 'grid-50-50': !isCompany }">
      <app-text-input
        [labelKey]="(isCompany ? 'contractor.name' : 'user.name') | toLL: 'capitalize'"
        formControlName="name"
        placeholderKey="{{ (isCompany ? 'contractor.name' : 'user.name') | locCap }} {{ getResidentTypeKey('D') | loc }}"
        [required]="true"
        [disabled]="disablePersonal"
      ></app-text-input>
      <app-text-input
        *ngIf="!isCompany"
        [labelKey]="'user.surname' | toLL: 'capitalize'"
        formControlName="lastName"
        placeholderKey="{{ 'user.surname' | locCap }} {{ getResidentTypeKey('D') | loc }}"
        [required]="true"
        [disabled]="disablePersonal"
      ></app-text-input>
    </div>
    <!-- It must be in simple div, because how CSS works-->
    <div *ngIf="!isCompany">
      <app-date-input
        [labelKey]="'user.birthDate' | toLL: 'capitalize'"
        formControlName="birthDate"
        placeholderKey="label.optional"
        [disabled]="disablePersonal"
      ></app-date-input>
    </div>
    <div class="grid-50-50">
      <ng-container *ngIf="!isCompany">
        <app-text-input
          labelKey="user.pesel"
          formControlName="PESEL"
          placeholderKey="label.optional"
          [disabled]="disablePersonal"
        ></app-text-input>
        <app-text-input
          labelKey="{{ 'user.documentNo' | loc }} ({{ 'user.documentNoTT' | loc }})"
          formControlName="documentNo"
          placeholderKey="label.optional"
          [disabled]="disablePersonal"
        ></app-text-input>
        <app-text-input
          [labelKey]="'user.national' | toLL: 'capitalize'"
          formControlName="nationality"
          placeholderKey="label.optional"
          [disabled]="disablePersonal"
        ></app-text-input>
      </ng-container>
      <app-text-input
        *ngIf="isCompany"
        labelKey="label.regon"
        formControlName="REGON"
        placeholderKey="label.regon"
        [required]="true"
        [disabled]="disablePersonal"
      ></app-text-input>
      <app-text-input
        [labelKey]="'user.ownerCode' | toLL: 'capitalize'"
        formControlName="ownerCode"
        placeholderKey="label.optional"
      ></app-text-input>
    </div>
  </app-form-section>

  <ng-container *ngIf="isCompany" [ngTemplateOutlet]="address"></ng-container>

  <app-form-section headerKey="label.email" extraDataKey="tooltip.appRequired">
    <app-user-communication-form
      #emailForm
      type="email"
      [defaultValues]="userEmails"
      [outsider]="outsider"
    ></app-user-communication-form>
  </app-form-section>
  <app-form-section headerKey="label.phone" extraDataKey="tooltip.appRequired">
    <app-user-communication-form
      #phoneForm
      type="phone"
      [defaultValues]="userPhones"
      [outsider]="outsider"
    ></app-user-communication-form>
  </app-form-section>
</form>

<ng-container *ngIf="!isCompany" [ngTemplateOutlet]="address"></ng-container>

<app-form-section
  *ngIf="showEmergencyContact && !outsider"
  [extraDataKey]="{ key: 'user.emergeContactTT', replaceMap: { $type: getResidentTypeKey('N') | loc } }"
>
  <ng-container section-header>
    {{ 'user.emergeContact' | locCap }}
    <app-slide-toggle-input
      [labelKey]="'label.' + (useEmergencyContact ? 'given' : 'empty') | toLL: 'capitalize'"
      [(ngModel)]="useEmergencyContact"
      (ngModelChange)="showDialog('useEmergencyContact', $event)"
      [ngModelOptions]="{ standalone: true }"
    ></app-slide-toggle-input>
  </ng-container>
  <form *ngIf="useEmergencyContact" [formGroup]="emergencyForm">
    <div class="grid-50-50">
      <app-text-input formControlName="name" labelKey="user.name" [required]="true" placeholderKey="user.name"> </app-text-input>
      <app-text-input formControlName="lastName" labelKey="user.surname" [required]="true" placeholderKey="user.surname">
      </app-text-input>
    </div>
    <div>
      <app-text-input
        formControlName="email"
        [labelKey]="'label.email' | toLL: 'capitalize'"
        [placeholderKey]="'label.email' | toLL: 'capitalize'"
      ></app-text-input>
    </div>
    <div>
      <app-contact-phone-type-form formControlName="phone"></app-contact-phone-type-form>
    </div>
    <mat-error *ngIf="emergencyForm.dirty"> {{ errorHandlingService.getErrorText(emergencyForm.errors) }} </mat-error>
  </form>
</app-form-section>

<ng-template #address>
  <app-form-section>
    <ng-container section-header>
      {{ (isCompany ? 'label.companyAddr' : 'user.postAddr') | locCap }}
      <app-slide-toggle-input
        *ngIf="!isCompany"
        [labelKey]="'label.' + (useAddress ? 'given' : 'empty') | toLL: 'capitalize'"
        [(ngModel)]="useAddress"
        (ngModelChange)="showDialog('useAddress', $event)"
        [ngModelOptions]="{ standalone: true }"
      ></app-slide-toggle-input>
    </ng-container>
    <form *ngIf="useAddress" [formGroup]="addressForm">
      <div class="row-reversed-3">
        <app-text-input
          labelKey="addr.street"
          formControlName="street"
          [required]="true"
          placeholderKey="addr.streetTT"
        ></app-text-input>
        <app-text-input
          labelKey="addr.blockUnit"
          formControlName="number"
          [required]="true"
          placeholderKey="addr.blockUnit"
        ></app-text-input>
      </div>
      <div class="row-3">
        <app-text-input
          labelKey="addr.zipCode"
          formControlName="zipCode"
          [required]="true"
          placeholderKey="addr.zipCode"
        ></app-text-input>
        <app-text-input labelKey="addr.city" formControlName="city" [required]="true" placeholderKey="addr.city"></app-text-input>
        <app-text-input
          labelKey="addr.country"
          formControlName="country"
          placeholderKey="({{ 'label.optional' | loc }})"
        ></app-text-input>
      </div>
    </form>
  </app-form-section>
</ng-template>
